import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-plus-icon]',
  template: `
    <svg:path
      d="M7.34375 3.40625L7.35938 3.28125L7.39062 3.15625L7.45312 3.04688L7.53125 2.9375L7.64062 2.85938L7.75 2.79688L7.875 2.76562L8 2.75L8.125 2.76562L8.25 2.79688L8.35938 2.85938L8.46875 2.9375L8.54688 3.04688L8.60938 3.15625L8.64062 3.28125L8.65625 3.40625V7.34375H12.6562L12.7812 7.375L12.8438 7.39062L12.9531 7.45312L13.0625 7.53125L13.1406 7.64062L13.2031 7.75L13.2344 7.875L13.25 8L13.2344 8.125L13.2031 8.25L13.1406 8.35938L13.0625 8.46875L12.9531 8.54688L12.8438 8.60938L12.7188 8.64062L12.5938 8.65625H8.65625V12.6562L8.625 12.7812L8.60938 12.8438L8.54688 12.9531L8.46875 13.0625L8.35938 13.1406L8.25 13.2031L8.125 13.2344L8 13.25L7.875 13.2344L7.75 13.2031L7.64062 13.1406L7.53125 13.0625L7.45312 12.9531L7.39062 12.8438L7.35938 12.7188L7.34375 12.5938V8.65625H3.34375L3.21875 8.625L3.15625 8.60938L3.04688 8.54688L2.9375 8.46875L2.85938 8.35938L2.79688 8.25L2.76562 8.125L2.75 8L2.76562 7.875L2.79688 7.75L2.85938 7.64062L2.9375 7.53125L3.04688 7.45312L3.15625 7.39062L3.28125 7.35938L3.40625 7.34375H7.34375V3.40625Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlusIcon {
  readonly viewBox = input<string>('0 0 16 16');
  readonly extraClass = input<string>('');
}
